module.exports = __webpack_public_path__ + "static/media/radio-10-pressed.e089a472.svg";